import React, { useState, useEffect, useRef, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { NavLink, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Downshift from "downshift";
import ResizeObserver from "react-resize-observer";

import PriceBoardDetailMode from "./PriceBoardDetailMode";
import PriceBoardOddDetailMode from "./PriceBoardOddDetailMode";

import PriceBoardBoxMode2 from "./PriceBoardBoxMode2";

import PriceBoardTotalMode from "./PriceBoardTotalMode";
import PriceBoardOddTotalMode from "./PriceBoardOddTotalMode";

import PriceBoardPutThrough from "./PriceBoardPutThrough";

import Footer from "./share-components/Footer";
import fileHDSD from "../assets/template/Huong_dan_su_dung_PriceVIP.pdf";

import {
   setForceUpdateTime,
   changePriceBoardViewMode,
   changePriceBoardIndexMode,
   setFindSymbol,
   changeTabRightState,
   addFavSymbol,
   changeSelectShowInfo,
   savePriceBoardColumnConfigToStorage,
   changeLanguage,
   removeUserFromStorage,
   updateLoadingStatus,
   addSummarySymbol,
   updateTabNameCurrent,
   getTabNameCurrentDisplayFromStorage,
} from "../redux/actions/sharedActions";
import { AuthConfig, TVSIPriceBoardHasAuth, constMarketCode, constTabName, constUrlPathMenu } from "../helpers/constData";

import { formatNumber, isNullOrEmpty, priceToNumber } from "../helpers/utils";
import { transByLanguage } from "../translations/i18n";
import PriceBoardDerivative from "./PriceBoardDerivative";
import { useApiCategoryStock } from "../helpers/apiCategoryStock";
import { Checkbox, Radio } from "antd";
import clsx from "clsx";
import PriceBoardTPRL from "./PriceBoardTPRLMode";
import PriceBoardExpandMode from "./PriceBoardExpandMode";
import { confirmAlert } from "react-confirm-alert";
import PriceBoardDetailModeAGGrid from "./PriceBoardDetailModeAGGrid";
import PriceBoardOddDetailModeAGGrid from "./PriceBoardOddDetailModeAGGrid";

export default function PriceBoard(props) {
   const { tabName, marketCode, indexCode, industryCode, isOddLot, underlying, favListid } = props;

   const isPutThrough = tabName === constTabName.ThoaThuan || tabName === constTabName.ThoaThuan_HSX || tabName === constTabName.ThoaThuan_HNX || tabName === constTabName.ThoaThuan_UpCOM;
   //

   const dispatch = useDispatch();
   let history = useHistory();

   const apiCategoryStock = useApiCategoryStock();

   const useDerivative = useSelector((state) => state.gShared.useDerivative);
   const gIndexInitTime = useSelector((state) => state.gIndex.initTime);
   const basketIndex = useSelector((state) => state.gIndex.basketIndex);
   const tabNameCurrent = useSelector((state) => state.gShared.tabNameCurrent);
   const [tabNameDisplay, setTabNameDisplay] = useState(getTabNameCurrentDisplayFromStorage());

   const {
      initTime: gSharedInitTime,
      industries,
      priceBoardFavSymbols,
      priceBoardFavSymbolsLength,
   } = useSelector(
      (state) => ({
         initTime: state.gShared.initTime,
         industries: state.gShared.industries,
         priceBoardFavSymbols: state.gShared.priceBoardFavSymbols,
         priceBoardFavSymbolsLength: state.gShared.priceBoardFavSymbols?.length ?? 0,
      }),
      (prev, next) => {
         return prev.initTime === next.initTime && prev.industries?.length === next.industries?.length && prev.priceBoardFavSymbolsLength === next.priceBoardFavSymbolsLength;
      }
   );

   const {
      initTime: gSymbolInitTime,
      symbolInfos: storedSymbolInfos,
      symbolTPRLInfos: storedSymbolTPRL,
   } = useSelector(
      (state) => ({
         initTime: state.gSymbol.initTime,
         symbolInfos: state.gSymbol.symbolInfos,
         symbolTPRLInfos: state.gSymbol.symbolTPRLInfos,
      }),
      (prev, next) => {
         return prev.initTime === next.initTime && prev.symbolInfos?.length === next.symbolInfos?.length && prev.symbolTPRLInfos?.length === next.symbolTPRLInfos?.length;
      }
   );

   const forceUpdateTime = useSelector((state) => state.gShared.forceUpdateTime);
   const language = useSelector((state) => state.gShared.language);
   const numberStockTop = useSelector((state) => state.gShared.numberStockTop);

   const priceBoardIndexMode = useSelector((state) => state.gShared.priceBoardIndexMode) ?? "";
   const priceBoardViewMode = useSelector((state) => state.gShared.priceBoardViewMode);

   const crrSortColumn = useSelector((state) => state.gShared.priceBoardSortConfig?.column) ?? "";
   const crrSortType = useSelector((state) => state.gShared.priceBoardSortConfig?.type) ?? "";
   const crrSortDataType = useSelector((state) => state.gShared.priceBoardSortConfig?.dataType) ?? "";
   const categoryStocks = useSelector((state) => state.gShared.categoryStocks) ?? [];
   const priceBoardSummarySymbols = useSelector((state) => state.gShared.priceBoardSummarySymbols) ?? [];

   const configShowHideColumn = useSelector((state) => state.gShared.configShowHideColumn);

   const configSortColumnMenu = useSelector((state) => state.gShared.configSortColumnMenu);

   const [searchValue, setSearchValue] = useState("");

   const refElementCalcSearchResult = useRef();

   const refElementCalcTopChild = useRef(null);
   const refMenuTopChild = useRef(null);

   const refElementCalcIndustryChild = useRef(null);
   const refMenuIndustryChild = useRef(null);

   const refElementCalcPutThroughChild = useRef(null);
   const refMenuPutThroughChild = useRef(null);

   const refElementCalcHSXChild = useRef(null);
   const refMenuHSXChild = useRef(null);

   const refElementCalcHNXChild = useRef(null);
   const refMenuHNXChild = useRef(null);

   const refElementCalcCKSHChild = useRef(null);
   const refMenuCKSHChild = useRef(null);

   const refElementCalcPSChild = useRef(null);
   const refMenuPSChild = useRef(null);

   const refEleCalExpandChild = useRef(null);
   const refMenuExpandChild = useRef(null);

   const refElementCalcUpCOMChild = useRef(null);
   const refMenuUpCOMChild = useRef(null);

   const refElementCalcConfigColumn = useRef(null);
   const refDivConfigColumn = useRef(null);
   const refDivSortConfigColumn = useRef(null);
   const refElementCalFilterColumn = useRef(null);

   const [menuPutThroughConfigHref, setMenutThroughConfigHref] = useState(constUrlPathMenu.ThoaThuan);
   const [menuPutThroughConfigTitle, setMenutThroughConfigTitle] = useState("");

   const [menuPSConfigHref, setMenuPSConfigHref] = useState(constUrlPathMenu.PS_VN30);
   const [menuPSConfigTitle, setMenuPSConfigTitle] = useState("");

   const [currentDisableInput, setCurrentDisableInput] = useState({});
   const [nameCategory, setNameCategory] = useState("");
   const [currentCategoryStock, setCurrentCategoryStock] = useState();

   const { t } = useTranslation();

   const [menuTopConfig, setMenuTopConfig] = useState({
      href: "",
      extTitle: "",
      extTitleEn: "",
      extTitleZh: "",
   });
   const [menuIndustryConfig, setMenuIndustryConfig] = useState({
      href: "/banggia/nganh/0",
      extTitle: "",
      extTitleEn: "",
      extTitleZh: "",
   });
   const [menuHSXConfig, setMenuHSXConfig] = useState({
      href: "/banggia/hsx",
      extTitle: "",
      extTitleEn: "",
      extTitleZh: "",
   });
   const [menuHNXConfig, setMenuHNXConfig] = useState({
      href: "/banggia/hnx",
      extTitle: "",
      extTitleEn: "",
      extTitleZh: "",
   });

   const [menuUpCOMConfig, setMenuUpCOMConfig] = useState({
      href: "/banggia/upcom",
      extTitle: "",
      extTitleEn: "",
      extTitleZh: "",
   });

   const [menuExpandConfig, setMenuExpandConfig] = useState({
      href: "/banggia/mo-rong",
      extTitle: "",
      extTitleEn: "",
      extTitleZh: "",
   });

   //
   const _getTabHref = () => {
      if (tabName && tabName !== "") {
         if (tabName === constTabName.TopTang) {
            setMenuTopConfig({
               href: constUrlPathMenu.TopTang,
               extTitle: transByLanguage("tang", "vi"),
               extTitleEn: transByLanguage("tang", "en"),
               extTitleZh: transByLanguage("tang", "zh"),
            });
         } else if (tabName === constTabName.TopTang_HSX) {
            setMenuTopConfig({
               href: constUrlPathMenu.TopTang_HSX,
               extTitle: transByLanguage("tang", "vi") + " - HSX",
               extTitleEn: transByLanguage("tang", "en") + " - HSX",
               extTitleZh: transByLanguage("tang", "zh") + " - HSX",
            });
         } else if (tabName === constTabName.TopTang_HNX) {
            setMenuTopConfig({
               href: constUrlPathMenu.TopTang_HNX,
               extTitle: transByLanguage("tang", "vi") + " - HNX",
               extTitleEn: transByLanguage("tang", "en") + " - HNX",
               extTitleZh: transByLanguage("tang", "zh") + "- HNX",
            });
         } else if (tabName === constTabName.TopTang_UpCOM) {
            setMenuTopConfig({
               href: constUrlPathMenu.TopTang_UpCOM,
               extTitle: transByLanguage("tang", "vi") + " - UpCOM",
               extTitleEn: transByLanguage("tang", "en") + " - UpCOM",
               extTitleZh: transByLanguage("tang", "zh") + "- UpCOM",
            });
         } else if (tabName === constTabName.TopGiam) {
            setMenuTopConfig({
               href: constUrlPathMenu.TopGiam,
               extTitle: transByLanguage("giam", "vi"),
               extTitleEn: transByLanguage("giam", "en"),
               extTitleZh: transByLanguage("giam", "zh"),
            });
         } else if (tabName === constTabName.TopGiam_HSX) {
            setMenuTopConfig({
               href: constUrlPathMenu.TopGiam_HSX,
               extTitle: transByLanguage("giam", "vi") + " - HSX",
               extTitleEn: transByLanguage("giam", "en") + " - HSX",
               extTitleZh: transByLanguage("giam", "zh") + "- HSX",
            });
         } else if (tabName === constTabName.TopGiam_HNX) {
            setMenuTopConfig({
               href: constUrlPathMenu.TopGiam_HNX,
               extTitle: transByLanguage("giam", "vi") + " - HNX",
               extTitleEn: transByLanguage("giam", "en") + " - HNX",
               extTitleZh: transByLanguage("giam", "zh") + "- HNX",
            });
         } else if (tabName === constTabName.TopGiam_UpCOM) {
            setMenuTopConfig({
               href: constUrlPathMenu.TopGiam_UpCOM,
               extTitle: transByLanguage("giam", "vi") + " - UpCOM",
               extTitleEn: transByLanguage("giam", "en") + " - UpCOM",
               extTitleZh: transByLanguage("giam", "zh") + "- UpCOM",
            });
         } else if (tabName === constTabName.TopKL) {
            setMenuTopConfig({
               href: constUrlPathMenu.TopKL,
               extTitle: transByLanguage("kl", "vi"),
               extTitleEn: transByLanguage("kl", "en"),
               extTitleZh: transByLanguage("kl", "zh"),
            });
         } else if (tabName === constTabName.TopKL_HSX) {
            setMenuTopConfig({
               href: constUrlPathMenu.TopKL_HSX,
               extTitle: transByLanguage("kl", "vi") + " - HSX",
               extTitleEn: transByLanguage("kl", "en") + " - HSX",
               extTitleZh: transByLanguage("kl", "zh") + " - HSX",
            });
         } else if (tabName === constTabName.TopKL_HNX) {
            setMenuTopConfig({
               href: constUrlPathMenu.TopKL_HNX,
               extTitle: transByLanguage("kl", "vi") + " - HNX",
               extTitleEn: transByLanguage("kl", "en") + " - HNX",
               extTitleZh: transByLanguage("kl", "zh") + "- HNX",
            });
         } else if (tabName === constTabName.TopKL_UpCOM) {
            setMenuTopConfig({
               href: constUrlPathMenu.TopKL_UpCOM,
               extTitle: transByLanguage("kl", "vi") + " - UpCOM",
               extTitleEn: transByLanguage("kl", "en") + " - UpCOM",
               extTitleZh: transByLanguage("kl", "zh") + "- UpCOM",
            });
         }
         // Top NN Mua
         else if (tabName === constTabName.TopNNMua) {
            setMenuTopConfig({
               href: constUrlPathMenu.TopNNMua,
               extTitle: transByLanguage("nnMua", "vi"),
               extTitleEn: transByLanguage("nnMua", "en"),
               extTitleZh: transByLanguage("nnMua", "zh"),
            });
         } else if (tabName === constTabName.TopNNMua_HSX) {
            setMenuTopConfig({
               href: constUrlPathMenu.TopNNMua_HSX,
               extTitle: transByLanguage("nnMua", "vi") + " - HSX",
               extTitleEn: transByLanguage("nnMua", "en") + " - HSX",
               extTitleZh: transByLanguage("nnMua", "zh") + " - HSX",
            });
         } else if (tabName === constTabName.TopNNMua_HNX) {
            setMenuTopConfig({
               href: constUrlPathMenu.TopNNMua_HNX,
               extTitle: transByLanguage("nnMua", "vi") + " - HNX",
               extTitleEn: transByLanguage("nnMua", "en") + " - HNX",
               extTitleZh: transByLanguage("nnMua", "zh") + " - HNX",
            });
         } else if (tabName === constTabName.TopNNMua_UpCOM) {
            setMenuTopConfig({
               href: constUrlPathMenu.TopNNMua_UpCOM,
               extTitle: transByLanguage("nnMua", "vi") + " - UpCOM",
               extTitleEn: transByLanguage("nnMua", "en") + " - UpCOM",
               extTitleZh: transByLanguage("nnMua", "zh") + " - UpCOM",
            });
         }
         // Top NN Ban
         else if (tabName === constTabName.TopNNBan) {
            setMenuTopConfig({
               href: constUrlPathMenu.TopNNBan,
               extTitle: transByLanguage("nnBan", "vi"),
               extTitleEn: transByLanguage("nnBan", "en"),
               extTitleZh: transByLanguage("nnBan", "zh"),
            });
         } else if (tabName === constTabName.TopNNBan_HSX) {
            setMenuTopConfig({
               href: constUrlPathMenu.TopNNBan_HSX,
               extTitle: transByLanguage("nnBan", "vi") + " - HSX",
               extTitleEn: transByLanguage("nnBan", "en") + " - HSX",
               extTitleZh: transByLanguage("nnBan", "zh") + " - HSX",
            });
         } else if (tabName === constTabName.TopNNBan_HNX) {
            setMenuTopConfig({
               href: constUrlPathMenu.TopNNBan_HNX,
               extTitle: transByLanguage("nnBan", "vi") + " - HNX",
               extTitleEn: transByLanguage("nnBan", "en") + " - HNX",
               extTitleZh: transByLanguage("nnBan", "zh") + " - HNX",
            });
         } else if (tabName === constTabName.TopNNBan_UpCOM) {
            setMenuTopConfig({
               href: constUrlPathMenu.TopNNBan_UpCOM,
               extTitle: transByLanguage("nnBan", "vi") + " - UpCOM",
               extTitleEn: transByLanguage("nnBan", "en") + " - UpCOM",
               extTitleZh: transByLanguage("nnBan", "zh") + " - UpCOM",
            });
         } else if (tabName === constTabName.ThoaThuan) {
            setMenutThroughConfigHref(constUrlPathMenu.ThoaThuan);
            setMenutThroughConfigTitle("");
         } else if (tabName === constTabName.ThoaThuan_HSX) {
            setMenutThroughConfigHref(constUrlPathMenu.ThoaThuan_HSX);
            setMenutThroughConfigTitle("HSX");

            // active tab thoa thuan
            setMenuHSXConfig({
               href: "/banggia/hsx/thoathuan",
               extTitle: "",
               extTitleEn: "",
               extTitleZh: "",
            });
         } else if (tabName === constTabName.ThoaThuan_HNX) {
            setMenutThroughConfigHref(constUrlPathMenu.ThoaThuan_HNX);
            setMenutThroughConfigTitle("HNX");
            // active tab thoa thuan
            setMenuHNXConfig({
               href: "/banggia/hnx/thoathuan",
               extTitle: "",
               extTitleEn: "",
               extTitleZh: "",
            });
         } else if (tabName === constTabName.ThoaThuan_UpCOM) {
            setMenutThroughConfigHref(constUrlPathMenu.ThoaThuan_UpCOM);
            setMenutThroughConfigTitle("UpCOM");
            // active tab thoa thuan
            setMenuUpCOMConfig({
               href: "/banggia/upcom/thoathuan",
               extTitle: "",
               extTitleEn: "",
               extTitleZh: "",
            });
         } else if (tabName === constTabName.PS_VN30) {
            setMenuPSConfigHref(constUrlPathMenu.PS_VN30);
            setMenuPSConfigTitle("");
         } else if (tabName === constTabName.PS_TPCP) {
            setMenuPSConfigHref(constUrlPathMenu.PS_TPCP);
            setMenuPSConfigTitle("");
         }
         //
         else if (tabName === "INDUSTRY") {
            if (industryCode !== undefined && industryCode !== null && industryCode !== "") {
               let _menuIndustryConfigHref = "/banggia/nganh/" + industryCode;
               let _menuIndustryConfigExtTitle = "";
               let _menuIndustryConfigExtTitleEn = "";
               let _menuIndustryConfigExtTitleZh = "";

               const industryInfo = industries.find((e) => e.code === industryCode);
               if (industryInfo) {
                  // _menuIndustryConfigExtTitle = industryInfo.name;
                  // _menuIndustryConfigExtTitleEn =
                  //   industryInfo.nameEn && industryInfo.nameEn !== ""
                  //     ? industryInfo.nameEn
                  //     : industryInfo.name;

                  _menuIndustryConfigExtTitle = transByLanguage(`codeIndustry_${industryInfo.code}`, "vi");
                  _menuIndustryConfigExtTitleEn = transByLanguage(`codeIndustry_${industryInfo.code}`, "en");
                  _menuIndustryConfigExtTitleZh = transByLanguage(`codeIndustry_${industryInfo.code}`, "zh");
               }

               setMenuIndustryConfig({
                  href: _menuIndustryConfigHref,
                  extTitle: _menuIndustryConfigExtTitle,
                  extTitleEn: _menuIndustryConfigExtTitleEn,
                  extTitleZh: _menuIndustryConfigExtTitleZh,
               });
            }
         }
      } else if (marketCode === constMarketCode.HSX) {
         if (isOddLot) {
            setMenuHSXConfig({
               href: "/banggia/hsx/odd",
               extTitle: transByLanguage("loLe", "vi"),
               extTitleEn: transByLanguage("loLe", "en"),
               extTitleZh: transByLanguage("loLe", "zh"),
            });
         } else if (isOddLot == false) {
            setMenuHSXConfig({
               href: "/banggia/hsx",
               extTitle: "",
               extTitleEn: "",
               extTitleZh: "",
            });
         } else if (indexCode === "VN30") {
            setMenuHSXConfig({
               href: "/banggia/vn30",
               extTitle: "",
               extTitleEn: "",
               extTitleZh: "",
            });
         }
      } else if (marketCode === constMarketCode.HNX) {
         if (isOddLot) {
            setMenuHNXConfig({
               href: "/banggia/hnx/odd",
               extTitle: transByLanguage("loLe", "vi"),
               extTitleEn: transByLanguage("loLe", "en"),
               extTitleZh: transByLanguage("loLe", "zh"),
            });
         } else if (isOddLot == false) {
            setMenuHNXConfig({
               href: "/banggia/hnx",
               extTitle: "",
               extTitleEn: "",
               extTitleZh: "",
            });
         } else if (indexCode === "HNX30") {
            setMenuHNXConfig({
               href: "/banggia/hnx30",
               extTitle: "",
               extTitleEn: "",
               extTitleZh: "",
            });
         }
      } else if (marketCode === constMarketCode.UpCOM) {
         if (isOddLot) {
            setMenuUpCOMConfig({
               href: "/banggia/upcom/odd",
               extTitle: transByLanguage("loLe", "vi"),
               extTitleEn: transByLanguage("loLe", "en"),
               extTitleZh: transByLanguage("loLe", "zh"),
            });
         } else if (isOddLot == false) {
            setMenuUpCOMConfig({
               href: "/banggia/upcom",
               extTitle: "",
               extTitleEn: "",
               extTitleZh: "",
            });
         } else if (indexCode === "HNX30") {
            setMenuUpCOMConfig({
               href: "/banggia/hnx30",
               extTitle: "",
               extTitleEn: "",
               extTitleZh: "",
            });
         }
      }
   };
   //
   const _changePriceBoardViewMode = (mode) => {
      dispatch(changePriceBoardViewMode(mode));
   };
   //
   const handleChangePriceBoardIndexMode = () => {
      try {
         dispatch(changePriceBoardIndexMode(priceBoardIndexMode));
      } catch (error) {
         console.log(error);
      }
   };
   //

   useEffect(() => {
      updateTabNameCurrent(dispatch, {
         marketCode: marketCode,
         indexCode: indexCode,
         tabName: tabName,
         tabNameDisplay: tabNameDisplay,
      });
   }, [marketCode, indexCode, tabName, tabNameDisplay]);

   const symbolInfos = useMemo(() => {
      let _symbolInfos = [];
      if (tabName && tabName !== "") {
         if (tabName === "CW") {
            // Chung quyen: securityType = CW
            _symbolInfos = storedSymbolInfos.filter((e) => e.securityType === "CW").sort((a, b) => (a.code < b.code ? -1 : 1));
         } else if (tabName === "FAV") {
            // Ua thich: Lay tu trong localStorage
            // const _favSymbols = priceBoardFavSymbols ?? [];
            const _favSymbols = categoryStocks.find((e) => e?.listid === currentCategoryStock?.listid)?.code ?? [];
            // console.log('FAV', _favSymbols);
            _symbolInfos = storedSymbolInfos.filter((e) => _favSymbols.indexOf(e.code) >= 0).sort((a, b) => (a.code < b.code ? -1 : 1));

            // dispatch({
            //   type: "SET_CATEGORY_STOCK",
            //   payload: currentCategoryStock?.id,
            // });
         } else if (tabName === constTabName.TongHop) {
            _symbolInfos = storedSymbolInfos.filter((e) => priceBoardSummarySymbols.indexOf(e.code) >= 0).sort((a, b) => (a.code < b.code ? -1 : 1));
         } else if (tabName === constTabName.TopTang) {
            _symbolInfos = storedSymbolInfos
               .filter((e) => priceToNumber(e.changePrice) > 0)
               .sort((a, b) => priceToNumber(b.changePrice) - priceToNumber(a.changePrice) || a.code.localeCompare(b.code))
               .slice(0, numberStockTop);
         } else if (tabName === constTabName.TopTang_HSX) {
            _symbolInfos = storedSymbolInfos
               .filter((e) => e.marketCode === constMarketCode.HSX && priceToNumber(e.changePrice) > 0)
               .sort((a, b) => priceToNumber(b.changePrice) - priceToNumber(a.changePrice) || a.code.localeCompare(b.code))
               .slice(0, numberStockTop);
         } else if (tabName === constTabName.TopTang_HNX) {
            _symbolInfos = storedSymbolInfos
               .filter((e) => e.marketCode === constMarketCode.HNX && priceToNumber(e.changePrice) > 0)
               .sort((a, b) => priceToNumber(b.changePrice) - priceToNumber(a.changePrice) || a.code.localeCompare(b.code))
               .slice(0, numberStockTop);
         } else if (tabName === constTabName.TopTang_UpCOM) {
            _symbolInfos = storedSymbolInfos
               .filter((e) => e.marketCode === constMarketCode.UpCOM && priceToNumber(e.changePrice) > 0)
               .sort((a, b) => priceToNumber(b.changePrice) - priceToNumber(a.changePrice) || a.code.localeCompare(b.code))
               .slice(0, numberStockTop);
         } else if (tabName === constTabName.TopGiam) {
            _symbolInfos = storedSymbolInfos
               .filter((e) => priceToNumber(e.changePrice) < 0)
               .sort((a, b) => priceToNumber(a.changePrice) - priceToNumber(b.changePrice) || a.code.localeCompare(b.code))
               .slice(0, numberStockTop);
         } else if (tabName === constTabName.TopGiam_HSX) {
            _symbolInfos = storedSymbolInfos
               .filter((e) => e.marketCode === constMarketCode.HSX && priceToNumber(e.changePrice) < 0)
               .sort((a, b) => priceToNumber(a.changePrice) - priceToNumber(b.changePrice) || a.code.localeCompare(b.code))
               .slice(0, numberStockTop);
         } else if (tabName === constTabName.TopGiam_HNX) {
            _symbolInfos = storedSymbolInfos
               .filter((e) => e.marketCode === constMarketCode.HNX && priceToNumber(e.changePrice) < 0)
               .sort((a, b) => priceToNumber(a.changePrice) - priceToNumber(b.changePrice) || a.code.localeCompare(b.code))
               .slice(0, numberStockTop);
         } else if (tabName === constTabName.TopGiam_UpCOM) {
            _symbolInfos = storedSymbolInfos
               .filter((e) => e.marketCode === constMarketCode.UpCOM && priceToNumber(e.changePrice) < 0)
               .sort((a, b) => priceToNumber(a.changePrice) - priceToNumber(b.changePrice) || a.code.localeCompare(b.code))
               .slice(0, numberStockTop);
         } else if (tabName === constTabName.TopKL) {
            _symbolInfos = storedSymbolInfos
               .filter((e) => priceToNumber(e.totalTradedQttyNM) > 0)
               .sort((a, b) => priceToNumber(b.totalTradedQttyNM) - priceToNumber(a.totalTradedQttyNM) || a.code.localeCompare(b.code))
               .slice(0, numberStockTop);
         } else if (tabName === constTabName.TopKL_HSX) {
            _symbolInfos = storedSymbolInfos
               .filter((e) => e.marketCode === constMarketCode.HSX && priceToNumber(e.totalTradedQttyNM) > 0)
               .sort((a, b) => priceToNumber(b.totalTradedQttyNM) - priceToNumber(a.totalTradedQttyNM) || a.code.localeCompare(b.code))
               .slice(0, numberStockTop);
         } else if (tabName === constTabName.TopKL_HNX) {
            _symbolInfos = storedSymbolInfos
               .filter((e) => e.marketCode === constMarketCode.HNX && priceToNumber(e.totalTradedQttyNM) > 0)
               .sort((a, b) => priceToNumber(b.totalTradedQttyNM) - priceToNumber(a.totalTradedQttyNM) || a.code.localeCompare(b.code))
               .slice(0, numberStockTop);
         } else if (tabName === constTabName.TopKL_UpCOM) {
            _symbolInfos = storedSymbolInfos
               .filter((e) => e.marketCode === constMarketCode.UpCOM && priceToNumber(e.totalTradedQttyNM) > 0)
               .sort((a, b) => priceToNumber(b.totalTradedQttyNM) - priceToNumber(a.totalTradedQttyNM) || a.code.localeCompare(b.code))
               .slice(0, numberStockTop);
         }
         // Top NN mua
         else if (tabName === constTabName.TopNNMua) {
            _symbolInfos = storedSymbolInfos
               .filter((e) => priceToNumber(e.buyForeignQtty) > 0)
               .sort((a, b) => priceToNumber(b.buyForeignQtty) - priceToNumber(a.buyForeignQtty) || a.code.localeCompare(b.code))
               .slice(0, numberStockTop);
         } else if (tabName === constTabName.TopNNMua_HSX) {
            _symbolInfos = storedSymbolInfos
               .filter((e) => e.marketCode === constMarketCode.HSX && priceToNumber(e.buyForeignQtty) > 0)
               .sort((a, b) => priceToNumber(b.buyForeignQtty) - priceToNumber(a.buyForeignQtty) || a.code.localeCompare(b.code))
               .slice(0, numberStockTop);
         } else if (tabName === constTabName.TopNNMua_HNX) {
            _symbolInfos = storedSymbolInfos
               .filter((e) => e.marketCode === constMarketCode.HNX && priceToNumber(e.buyForeignQtty) > 0)
               .sort((a, b) => priceToNumber(b.buyForeignQtty) - priceToNumber(a.buyForeignQtty) || a.code.localeCompare(b.code))
               .slice(0, numberStockTop);
         } else if (tabName === constTabName.TopNNMua_UpCOM) {
            _symbolInfos = storedSymbolInfos
               .filter((e) => e.marketCode === constMarketCode.UpCOM && priceToNumber(e.buyForeignQtty) > 0)
               .sort((a, b) => priceToNumber(b.buyForeignQtty) - priceToNumber(a.buyForeignQtty) || a.code.localeCompare(b.code))
               .slice(0, numberStockTop);
         }
         // Top NN ban
         else if (tabName === constTabName.TopNNBan) {
            _symbolInfos = storedSymbolInfos
               .filter((e) => priceToNumber(e.sellForeignQtty) > 0)
               .sort((a, b) => priceToNumber(b.sellForeignQtty) - priceToNumber(a.sellForeignQtty) || a.code.localeCompare(b.code))
               .slice(0, numberStockTop);
         } else if (tabName === constTabName.TopNNBan_HSX) {
            _symbolInfos = storedSymbolInfos
               .filter((e) => e.marketCode === constMarketCode.HSX && priceToNumber(e.sellForeignQtty) > 0)
               .sort((a, b) => priceToNumber(b.sellForeignQtty) - priceToNumber(a.sellForeignQtty) || a.code.localeCompare(b.code))
               .slice(0, numberStockTop);
         } else if (tabName === constTabName.TopNNBan_HNX) {
            _symbolInfos = storedSymbolInfos
               .filter((e) => e.marketCode === constMarketCode.HNX && priceToNumber(e.sellForeignQtty) > 0)
               .sort((a, b) => priceToNumber(b.sellForeignQtty) - priceToNumber(a.sellForeignQtty) || a.code.localeCompare(b.code))
               .slice(0, numberStockTop);
         } else if (tabName === constTabName.TopNNBan_UpCOM) {
            _symbolInfos = storedSymbolInfos
               .filter((e) => e.marketCode === constMarketCode.UpCOM && priceToNumber(e.sellForeignQtty) > 0)
               .sort((a, b) => priceToNumber(b.sellForeignQtty) - priceToNumber(a.sellForeignQtty) || a.code.localeCompare(b.code))
               .slice(0, numberStockTop);
         }
         //
         else if (tabName === "INDUSTRY") {
            let industryName = "";
            if (industryCode !== undefined && industryCode !== null && industryCode !== "") {
               const industryInfo = industries.find((e) => e.code === industryCode);
               if (industryInfo) {
                  industryName = industryInfo.name;
                  const symbolsByIndustryCode = industryInfo.symbolList;
                  _symbolInfos = storedSymbolInfos.filter((e) => symbolsByIndustryCode.indexOf(e.code) >= 0);
               }
            }
         }
      } else if (marketCode) {
         if (indexCode && indexCode !== "") {
            const symbolsByIndexCode = (basketIndex[indexCode] ?? "").split(",");
            _symbolInfos = storedSymbolInfos.filter((e) => e.marketCode === marketCode && e.securityType !== "CW" && e.securityType !== "BO" && symbolsByIndexCode.indexOf(e.code) >= 0);
         } else if (marketCode === constMarketCode.Bond) {
            _symbolInfos = storedSymbolInfos.filter((e) => e.marketCode === marketCode);
         } else if (marketCode === constMarketCode.Derivative) {
            if (underlying == "vn30") {
               _symbolInfos = storedSymbolInfos.filter((e) => e.marketCode === marketCode && e.underlying === "VN30");
            } else {
               _symbolInfos = storedSymbolInfos.filter((e) => e.marketCode === marketCode && e.underlying !== "VN30");
            }

            // _symbolInfos = storedSymbolInfos.filter((e) => e.marketCode === 'STO' && e.securityType !== "CW" && e.securityType !== "BO").slice(0, 10);
         } //Trái phiếu riêng lẻ
         else if (marketCode === constMarketCode.TPRL) {
            //tạm thời lấy dữ liệu của Derivative
            _symbolInfos = storedSymbolTPRL;
         } else {
            _symbolInfos = storedSymbolInfos.filter((e) => e.marketCode === marketCode && e.securityType !== "CW" && e.securityType !== "BO");
         }
         //
         _symbolInfos = _symbolInfos.sort((a, b) => (a.code < b.code ? -1 : 1));
      }

      if (crrSortColumn && priceBoardViewMode !== "BOX" && tabName?.indexOf("TOP_") !== 0) {
         let trueValue = -1;
         let falseValue = 1;

         if (crrSortType && crrSortType === "desc") {
            trueValue = 1;
            falseValue = -1;
         }

         if (crrSortDataType && crrSortDataType === "number") {
            _symbolInfos = _symbolInfos.sort((a, b) => (Number((a[crrSortColumn] ?? "").replace(/,/g, "")) < Number((b[crrSortColumn] ?? "").replace(/,/g, "")) ? trueValue : falseValue));
         } else {
            _symbolInfos = _symbolInfos.sort((a, b) => (a[crrSortColumn].localeCompare(b[crrSortColumn]) < 0 ? trueValue : a[crrSortColumn].localeCompare(b[crrSortColumn]) > 0 ? falseValue : 0));
         }
      }

      // _symbolInfos = _symbolInfos.map((e) => ({
      //   code: e.code,
      //   counter: e.counter,
      // }));

      // Đẩy danh mục quan tâm lên đầu
      function prioritizeFavorites(arr1, arr2) {
         let result = arr1.slice();
         arr2.forEach((item2) => {
            const foundIndex = result.findIndex((item1) => item1.code === item2.code);
            if (foundIndex !== -1) {
               const [favoriteItem] = result.splice(foundIndex, 1);
               result.unshift(favoriteItem);
            }
         });

         return result;
      }
      //
      _symbolInfos = prioritizeFavorites(
         _symbolInfos,
         priceBoardFavSymbols.map((item) => ({ code: item }))
      );

      // lấy ra phần tử cuối
      const lastElement = _symbolInfos
         .map((item) => ({ code: item.code }))
         .filter((item) => priceBoardFavSymbols.includes(item.code))
         .pop()?.code;
      dispatch({
         type: "SET_LAST_SYMBOL",
         payload: lastElement,
      });

      //
      return _symbolInfos;
   }, [
      forceUpdateTime,
      gSharedInitTime,
      gSymbolInitTime,
      gIndexInitTime,
      tabName,
      marketCode,
      indexCode,
      industryCode,
      crrSortColumn,
      crrSortType,
      priceBoardFavSymbolsLength,
      currentCategoryStock,
      categoryStocks,
      priceBoardSummarySymbols,
      tabNameCurrent,
   ]);

   //
   useEffect(() => {
      _getTabHref();
      const _intervalId = setInterval(_reloadTapTop, 10000);
      return () => {
         clearInterval(_intervalId);
      };
   }, [forceUpdateTime, tabName, industryCode, marketCode, isOddLot]);

   const _reloadTapTop = () => {
      if (tabName && tabName.indexOf("TOP_") == 0) {
         setForceUpdateTime(dispatch);
      }
   };

   const _calcMenuTopChildPosition = () => {
      if (refElementCalcTopChild.current && refMenuTopChild.current) {
         const rect = refElementCalcTopChild.current._node.getBoundingClientRect();
         refMenuTopChild.current.style.left = rect.x + "px";
         refMenuTopChild.current.style.top = rect.y + rect.height + "px";
      } else {
         setTimeout(() => {
            _calcMenuTopChildPosition();
         }, 500);
      }
   };

   const _calcMenuIndustryChildPosition = () => {
      if (refElementCalcIndustryChild.current && refMenuIndustryChild.current) {
         const rect = refElementCalcIndustryChild.current._node.getBoundingClientRect();
         refMenuIndustryChild.current.style.left = rect.x + "px";
         refMenuIndustryChild.current.style.top = rect.y + rect.height + "px";
      } else {
         setTimeout(() => {
            _calcMenuIndustryChildPosition();
         }, 500);
      }
   };

   const _calcMenuPutThroughChildPosition = () => {
      if (refElementCalcPutThroughChild.current && refMenuPutThroughChild.current) {
         const rect = refElementCalcPutThroughChild.current._node.getBoundingClientRect();
         refMenuPutThroughChild.current.style.left = rect.x + "px";
         refMenuPutThroughChild.current.style.top = rect.y + rect.height + "px";
         refMenuPutThroughChild.current.style.minWidth = rect.width + "px";
      } else {
         setTimeout(() => {
            _calcMenuPutThroughChildPosition();
         }, 500);
      }
   };

   const _calcMenuHSXChildPosition = () => {
      if (refElementCalcHSXChild.current && refMenuHSXChild.current) {
         const rect = refElementCalcHSXChild.current._node.getBoundingClientRect();
         refMenuHSXChild.current.style.left = rect.x + "px";
         refMenuHSXChild.current.style.top = rect.y + rect.height + "px";
         refMenuHSXChild.current.style.minWidth = rect.width + "px";
      } else {
         setTimeout(() => {
            _calcMenuHSXChildPosition();
         }, 500);
      }
   };

   const _calcMenuHNXChildPosition = () => {
      if (refElementCalcHNXChild.current && refMenuHNXChild.current) {
         const rect = refElementCalcHNXChild.current._node.getBoundingClientRect();
         refMenuHNXChild.current.style.left = rect.x + "px";
         refMenuHNXChild.current.style.top = rect.y + rect.height + "px";
         refMenuHNXChild.current.style.minWidth = rect.width + "px";
      } else {
         setTimeout(() => {
            _calcMenuHNXChildPosition();
         }, 500);
      }
   };

   const _calcMenuUpCOMChildPosition = () => {
      if (refElementCalcUpCOMChild.current && refMenuUpCOMChild.current) {
         const rect = refElementCalcUpCOMChild.current._node.getBoundingClientRect();
         refMenuUpCOMChild.current.style.left = rect.x + "px";
         refMenuUpCOMChild.current.style.top = rect.y + rect.height + "px";
         refMenuUpCOMChild.current.style.minWidth = rect.width + "px";
      } else {
         setTimeout(() => {
            _calcMenuUpCOMChildPosition();
         }, 500);
      }
   };

   const _calcSearchResultPosition = () => {
      const el = document.getElementById("suggestion-results");
      if (refElementCalcSearchResult.current && el) {
         const rect = refElementCalcSearchResult.current._node.getBoundingClientRect();
         el.style.left = rect.x + "px";
         el.style.top = rect.y + rect.height + "px";
      } else {
         setTimeout(() => {
            _calcSearchResultPosition();
         }, 500);
      }
   };

   const _calcMenuCKSHChildPosition = () => {
      if (refElementCalcCKSHChild.current && refMenuCKSHChild.current) {
         const rect = refElementCalcCKSHChild.current._node.getBoundingClientRect();
         refMenuCKSHChild.current.style.left = rect.x + "px";
         refMenuCKSHChild.current.style.top = rect.y + rect.height + "px";
         refMenuCKSHChild.current.style.minWidth = rect.width + "px";
      } else {
         setTimeout(() => {
            _calcMenuCKSHChildPosition();
         }, 500);
      }
   };

   const _calcMenuPSChildPosition = () => {
      if (refElementCalcPSChild.current && refMenuPSChild.current) {
         const rect = refElementCalcPSChild.current._node.getBoundingClientRect();
         refMenuPSChild.current.style.left = rect.x + "px";
         refMenuPSChild.current.style.top = rect.y + rect.height + "px";
         refMenuPSChild.current.style.minWidth = rect.width + "px";
      } else {
         setTimeout(() => {
            _calcMenuPSChildPosition();
         }, 500);
      }
   };

   const _calcMenuExpandChildPosition = () => {
      if (refEleCalExpandChild.current && refMenuExpandChild.current) {
         const rect = refEleCalExpandChild.current._node.getBoundingClientRect();
         refMenuExpandChild.current.style.left = rect.x + "px";
         refMenuExpandChild.current.style.top = rect.y + rect.height + "px";
         refMenuExpandChild.current.style.minWidth = rect.width + "px";
      } else {
         setTimeout(() => {
            _calcMenuExpandChildPosition();
         }, 500);
      }
   };

   const _calcMenuCalcConfigPosition = () => {
      if (refElementCalcConfigColumn.current && refDivConfigColumn.current) {
         const rect = refElementCalcConfigColumn.current._node.getBoundingClientRect();
         refDivConfigColumn.current.style.left = rect.x - 115 + rect.width + "px";
         refDivConfigColumn.current.style.top = rect.y + rect.height + "px";
         refDivConfigColumn.current.style.minWidth = rect.width + "px";
      } else {
         setTimeout(() => {
            _calcMenuCalcConfigPosition();
         }, 500);
      }
   };

   const _calcMenuSortColumnmConfigPosition = () => {
      if (refElementCalFilterColumn.current && refDivSortConfigColumn.current) {
         const rect = refElementCalFilterColumn.current._node.getBoundingClientRect();
         refDivSortConfigColumn.current.style.left = rect.x - 250 + rect.width + "px";
         refDivSortConfigColumn.current.style.top = rect.y + rect.height + "px";
         refDivSortConfigColumn.current.style.minWidth = rect.width + "px";
      } else {
         setTimeout(() => {
            _calcMenuSortColumnmConfigPosition();
         }, 500);
      }
   };

   const _calcMemuChildPos = () => {
      _calcMenuTopChildPosition();
      _calcMenuIndustryChildPosition();
      _calcMenuPutThroughChildPosition();
      _calcMenuHSXChildPosition();
      _calcMenuHNXChildPosition();
      _calcSearchResultPosition();
      _calcMenuCKSHChildPosition();
      _calcMenuPSChildPosition();
      _calcMenuCalcConfigPosition();
      _calcMenuUpCOMChildPosition();
      _calcMenuExpandChildPosition();
   };

   useEffect(() => {
      dispatch({
         type: "ChangeIsOddlot",
         payload: isOddLot ?? false,
      });
   }, [isOddLot]);

   useEffect(() => {
      _calcMemuChildPos();
   }, [priceBoardIndexMode]);

   useEffect(() => {
      if (favListid) {
         setCurrentCategoryStock({
            listid: favListid,
            listname: categoryStocks?.find((x) => x?.listid === favListid)?.listname ?? "-",
         });
         dispatch({
            type: "SET_CATEGORY_STOCK",
            payload: favListid,
         });
      }
   }, [favListid]);
   useEffect(() => {
      const _intervalId = setInterval(_calcMemuChildPos, 3000);
      return () => {
         clearInterval(_intervalId);
         changeTabRightState(dispatch, true);
      };
   }, []);

   //
   const _handleSearchValueChange = (code) => {
      if (code && code !== "") {
         code = code.toUpperCase();
         //trungdh check TP được search có trong danh sách của TAB hay không ?
         if (!symbolInfos.find((x) => x.code === code) && tabName !== constTabName.TongHop && tabName !== constTabName.Fav) {
            confirmAlert({
               closeOnEscape: false,
               closeOnClickOutside: false,
               customUI: ({ onClose }) => {
                  return (
                     <div className="react-confirm-warning">
                        <div className="react-confirm-warning-body">
                           <div className="react-confirm-warning-icon">
                              <i className="fa fa-exclamation-circle"></i>
                           </div>
                           <div className="react-confirm-warning-body--content">
                              <p className="text-center">
                                 {language === "en"
                                    // ? `You're viewing the ${tabNameCurrent?.tabNameDisplay} category, so you can only add the code of ${tabNameCurrent?.tabNameDisplay} !`
                                    ? `Stock code not found!`
                                    : language === "zh"
                                    ? `您正在查看 ${tabNameCurrent?.tabNameDisplay} 名單, 所以只能添加 ${tabNameCurrent?.tabNameDisplay} 的代碼 !`
                                    : language === "kr"
                                    ? `현재 ${tabNameCurrent?.tabNameDisplay} 목록을 보고 있으므로 ${tabNameCurrent?.tabNameDisplay} 코드만 추가할 수 있습니다 !`
                                    // : `Bạn đang xem danh  ${tabNameCurrent?.tabNameDisplay}, nên chỉ thêm được mã của ${tabNameCurrent?.tabNameDisplay} !`}
                                    : `Không tìm thấy mã chứng khoán!`}
                              </p>
                           </div>

                           <div className="text-center">
                              <button
                                 type="button"
                                 className="btn-close"
                                 onClick={() => {
                                    onClose();
                                 }}
                              >
                                 {t("OK")}
                              </button>
                           </div>
                        </div>
                     </div>
                  );
               },
            });
            return;
         }
         //co dang nhap: them yeu thich
         //khong : search

         if (tabName === constTabName.Fav && TVSIPriceBoardHasAuth === AuthConfig.Yes) {
            handleAddStockIntoCategory(code);
         } else if (tabName === constTabName.TongHop) {
            addSummarySymbol(dispatch, code);
         }
         // longdh comment sửa vào mode tab FAV và login đã có case bên trên
         // else if (currentCategoryStock) {
         //   handleAddStockIntoCategory(code);
         // }
         else {
            // // tạm mở cho tìm đủ các mã
            // const _symbolInfo = storedSymbolInfos.find((e) => e.code === code);
            // const _securityType = _symbolInfo?.securityType;
            // const _marketCode = _symbolInfo?.marketCode;
            // if (_securityType === "CW") {
            //    history.push("/banggia/chungquyen");
            // } else if (_marketCode === constMarketCode.HNX) {
            //    history.push("/banggia/hnx");
            // } else if (_marketCode === constMarketCode.HSX) {
            //    history.push("/banggia/hsx");
            // } else if (_marketCode === constMarketCode.UpCOM) {
            //    history.push("/banggia/upcom");
            // } else if (_marketCode === constMarketCode.Bond) {
            //    history.push("/banggia/traiphieu");
            // }
            // // else if (_marketCode === constMarketCode.Derivative) {
            // //   history.push("/banggia/phaisinh");
            // // }

            setFindSymbol(dispatch, code);
         }
         // addFavSymbol(dispatch, code);
         // setFindSymbol(dispatch, code);
         setSearchValue("");
      }
   };

   const _handleSearchValueChangeTPRL = (p_code) => {
      if (p_code && p_code !== "") {
         addFavSymbol(dispatch, p_code.toUpperCase());
         setSearchValue("");
      }
   };

   const _handleSearchKeyDown = (event) => {
      if (event.defaultPrevented === false && event.keyCode === 13 && tabNameCurrent?.marketCode !== constMarketCode.TPRL) {
         _handleSearchValueChange(event.target.value);
      } else {
         _handleSearchValueChangeTPRL(event.target.value);
      }
   };

   const { i18n } = useTranslation();

   const { concurrentInfo } = useSelector(
      (state) => ({
         concurrentInfo: state.gShared.concurrentInfo,
      }),
      (prev, next) => {
         return prev.concurrentInfo?.time === next.concurrentInfo?.time;
      }
   );
   const serverTime = useSelector((state) => state.gShared.serverTime);
   const serverDate = serverTime > 0 ? new Date(serverTime) : new Date();
   const userName = useSelector((state) => state.gUser.userName ?? "");
   const userToken = useSelector((state) => state.gUser.token ?? "");

   const _changeLanguage = (lng) => {
      i18n.changeLanguage(lng);
      changeLanguage(dispatch, lng);
   };

   const handleChangeLanguage = (e) => {
      _changeLanguage(e);
   };

   const _clearUserMem = () => {
      removeUserFromStorage();
      dispatch({ type: "ClearUser" });
   };

   const _userLogout = () => {
      localStorage.setItem("pathLocation", window.location.pathname);
      _clearUserMem();
   };

   useEffect(() => {
      if (isNullOrEmpty(userToken)) {
         _clearUserMem();
      }
   }, [userToken]);

   const getCategoryStock = async () => {
      const { data: loaded } = await apiCategoryStock.CategoryStock();
      dispatch({
         type: "GET_CATEGORY_STOCK",
         payload: loaded.arrCata,
      });
   };

   const handleAddStockIntoCategory = (code) => {
      if (currentCategoryStock) {
         apiCategoryStock
            .EditGroupStock({
               lstid: currentCategoryStock?.listid,
               code: code,
               type: "A",
            })
            .then((res) => {
               if (res.status === 200) {
                  setSearchValue("");
               }
            })
            .catch((err) => {
               console.log("err => ", err);
            })
            .finally(() => {
               getCategoryStock();
            });
      }
   };

   const handleKeyDownChangeCategoryStock = (e) => {
      if (e.code === "Enter" || e.type === "click") {
         if (currentDisableInput == null || currentDisableInput.listname == null || currentDisableInput.listname == undefined || currentDisableInput.listname == "") {
            return;
         }

         apiCategoryStock
            .EditGroupStock({
               lstid: currentDisableInput?.listid,
               newNameCata: currentDisableInput.listname,
            })
            .then((res) => {
               if (res.status === 200) {
                  dispatch({
                     type: "EDIT_CATEGORY_STOCK_NAME",
                     payload: {
                        lstid: currentDisableInput?.listid,
                        listname: currentDisableInput.listname,
                     },
                  });
                  setCurrentCategoryStock({
                     listid: currentDisableInput?.listid,
                     listname: currentDisableInput.listname,
                  });
               }
            })
            .catch((err) => {
               console.log("err => ", err);
            })
            .finally(() => {
               getCategoryStock();
               setCurrentDisableInput({
                  listid: currentDisableInput?.listid,
                  listname: currentDisableInput?.listname,
                  isDisable: true,
               });
            });
      }
   };

   const handleChangeCategoryName = (e) => {
      setNameCategory(e.target.value);
   };

   const handleChangeInputCategory = (e) => {
      setCurrentDisableInput({
         ...currentDisableInput,
         listname: e.target.value,
      });
   };

   const handleRemoveCategoryStock = (id) => {
      updateLoadingStatus(dispatch, true);
      apiCategoryStock
         .DeleteGroupCategoryStock({ lstid: id })
         .then((res) => {
            if (res.status === 200) {
               getCategoryStock();
               setCurrentCategoryStock(null);
               updateLoadingStatus(dispatch, false);
            }
         })
         .catch((err) => {
            updateLoadingStatus(dispatch, false);
            console.log("err =>", err);
         });
   };

   const handleKeydownCategory = (event) => {
      if (event.key === "Enter") {
         handleAddCategoryName();
      }
   };

   const handleAddCategoryName = () => {
      if (nameCategory == null || nameCategory == undefined || nameCategory == "") {
         return;
      }

      apiCategoryStock
         .CreateCategoryStock({ nameCata: nameCategory })
         .then((res) => {
            if (res.status === 200) {
               dispatch({
                  type: "ADD_CATEGORY_STOCK",
                  payload: { name: nameCategory },
               });
            }
         })
         .catch((err) => {
            console.log("err =>", err);
         })
         .finally(() => {
            getCategoryStock();
            setNameCategory("");
         });
   };

   const listCategory = useMemo(() => {
      if (currentCategoryStock && currentCategoryStock.listid) {
         var category = categoryStocks.find((e) => e.listid == currentCategoryStock.listid);
         if (category) {
            setCurrentCategoryStock(category);
         } else {
            setCurrentCategoryStock(null);
         }
      }

      if (categoryStocks.length > 0) {
         return (
            <div className="listown__list">
               {categoryStocks.map((e, idx) => (
                  <button
                     key={idx}
                     value={e?.listid}
                     className="listown__btn"
                     onClick={() => {
                        history.push("/banggia/fav/" + e?.listid);
                        setCurrentCategoryStock(e);
                        dispatch({
                           type: "SET_CATEGORY_STOCK",
                           payload: e?.listid,
                        });
                     }}
                  >
                     <input
                        value={e?.listid === currentDisableInput?.listid ? currentDisableInput?.listname : e?.listname}
                        className={currentDisableInput && currentDisableInput?.isDisable === false && currentDisableInput?.listid === e?.listid ? "active" : "inActive"}
                        readOnly={currentDisableInput && currentDisableInput?.isDisable === false && currentDisableInput?.listid === e?.listid ? false : true}
                        onKeyDown={handleKeyDownChangeCategoryStock}
                        onChange={handleChangeInputCategory}
                        style={{ cursor: currentDisableInput && currentDisableInput?.isDisable === false && currentDisableInput?.listid === e?.listid ? "" : "pointer" }}
                     />
                     {currentDisableInput && currentDisableInput?.isDisable === false && currentDisableInput?.listid === e?.listid ? (
                        <div className="d-flex align-items-center ml-2" style={{ gap: "8px" }}>
                           <span onClick={(e) => handleKeyDownChangeCategoryStock(e)}>
                              <i className="fa fa-edit"></i>
                           </span>

                           <span
                              onClick={() => {
                                 setCurrentDisableInput({});
                              }}
                           >
                              <i className="fa fa-times"></i>
                           </span>
                        </div>
                     ) : (
                        <div className="d-flex align-items-center ml-2" style={{ gap: "8px" }}>
                           <span onClick={() => handleRemoveCategoryStock(e?.listid)}>
                              <i className="fa fa-times"></i>
                           </span>

                           <span
                              onClick={() => {
                                 setCurrentDisableInput({
                                    listid: e?.listid,
                                    listname: e?.listname,
                                    isDisable: false,
                                 });
                              }}
                           >
                              <i className="fa fa-cog"></i>
                           </span>
                        </div>
                     )}
                  </button>
               ))}
            </div>
         );
      }
      return <></>;
   }, [categoryStocks, currentDisableInput]);

   // highlight vào đầu danh sách suggest
   useEffect(() => {
      const el = document.getElementById("suggestion-results");

      if (el && el.firstElementChild) {
         el.firstElementChild.setAttribute("class", "highlighted");
         el.firstElementChild.setAttribute("aria-selected", true);
      }
   }, [searchValue]);

   const onChangeConfigColumn = (checkedValues) => {
      dispatch({
         type: "SET_CONFIG_SHOWHIDE_COLUMN",
         payload: checkedValues,
      });
   };

   const onChangeSortConfigColumn = (checkedValues) => {
      dispatch({
         type: "SET_CONFIG_SORT_COLUMN_MENU",
         payload: checkedValues.target.value,
      });
   };

   return (
      <>
         {props.isAutoScroll ? (
            <></>
         ) : (
            <div className={"price-menu"} style={{ paddingLeft: 20, paddingRight: 20 }}>
               <div className="price-menu-left">
                  {priceBoardIndexMode && priceBoardIndexMode === "HIDDEN" ? (
                     <button type="button" onClick={handleChangePriceBoardIndexMode}>
                        <i className="fas fa-chevron-down"></i>
                     </button>
                  ) : (
                     <button type="button" onClick={handleChangePriceBoardIndexMode}>
                        <i className="fas fa-chevron-up"></i>
                     </button>
                  )}
                  <div className="boxsearch-stockcode">
                     <ResizeObserver ref={refElementCalcSearchResult} onResize={_calcSearchResultPosition} onPosition={_calcSearchResultPosition} onReflow={_calcSearchResultPosition} />
                     <Downshift
                        onChange={(selection, agrs) => {
                           if (tabNameCurrent?.marketCode === constMarketCode.TPRL) {
                              _handleSearchValueChangeTPRL(selection ? selection.value : "");
                           } else if (tabNameCurrent.tabNameDisplay === constTabName.Fav) {
                              _handleSearchValueChange(selection ? selection.value : "");
                              handleAddStockIntoCategory(selection);
                           } else {
                              _handleSearchValueChange(selection ? selection.value : "");
                           }
                        }}
                        itemToString={(item) => {
                           return item ? item.value : "";
                        }}
                        onInputValueChange={(value) => {
                           setSearchValue(value);
                        }}
                        inputValue={searchValue}
                        onOuterClick={() => {
                           setSearchValue("");
                        }}
                     >
                        {({ getInputProps, getItemProps, getLabelProps, getMenuProps, isOpen, inputValue, highlightedIndex, selectedItem }) => {
                           let results = [];
                           if (inputValue && inputValue !== "") {
                              let sourceSymbols = tabNameCurrent?.marketCode === constMarketCode.TPRL ? storedSymbolTPRL : storedSymbolInfos;
                              results = sourceSymbols
                                 .filter(
                                    (item) => item.code.includes(inputValue.toUpperCase())
                                    // tạm mở cho tìm đủ các mã
                                    // item.code.includes(inputValue.toUpperCase()) && symbolInfos.map(v=> v.code).includes(item?.code)
                                 )
                                 .sort((a, b) => a.code.indexOf(inputValue.toUpperCase()) - b.code.indexOf(inputValue.toUpperCase()) || a.code.localeCompare(b.code))
                                 .map((item) => {
                                    return {
                                       value: item.code,
                                       content: item.symbolName,
                                       marketName: item.marketName,
                                       matchIndex: item.code.indexOf(inputValue.toUpperCase()),
                                    };
                                 });
                           }
                           return (
                              <div className="position-relative">
                                 {/* {console.log(tabNameCurrent, "tabNameCurrent")} */}
                                 {tabNameCurrent?.marketCode === constMarketCode.TPRL ? (
                                    <input
                                       className="inputTPRL"
                                       placeholder={t("nhapMaTP")}
                                       {...getInputProps({
                                          onKeyDown: (e) => {
                                             if (e.key === "Enter" && highlightedIndex === null) {
                                                _handleSearchKeyDown(e);
                                             }
                                          },
                                       })}
                                    />
                                 ) : (
                                    <input
                                       placeholder={t("nhapMaCK")}
                                       {...getInputProps({
                                          onKeyDown: (e) => {
                                             if (e.key === "Enter" && highlightedIndex === null) {
                                                _handleSearchKeyDown(e);
                                                handleAddStockIntoCategory(results[0]?.value);
                                             }
                                          },
                                       })}
                                    />
                                 )}

                                 <span className="position-absolute hook">
                                    <i className="fas fa-search "></i>
                                 </span>
                                 <ul {...getMenuProps()} id={"suggestion-results"} className="suggestion-results" style={{ display: isOpen ? "" : "none" }}>
                                    {isOpen
                                       ? results.map((item, index) => (
                                            <li
                                               key={index}
                                               {...getItemProps({
                                                  key: item.value,
                                                  index,
                                                  item,
                                               })}
                                               className={highlightedIndex === index ? "highlighted" : ""}
                                               onClick={() => {
                                                  if (tabNameCurrent?.marketCode === constMarketCode.TPRL) {
                                                     _handleSearchValueChangeTPRL(item?.value);
                                                  } else if (tabNameCurrent.tabNameDisplay === constTabName.Fav) {
                                                     handleAddStockIntoCategory(item?.value);
                                                     _handleSearchValueChange(item?.value);
                                                  } else {
                                                     _handleSearchValueChange(item?.value);
                                                  }
                                               }}
                                            >
                                               <p>
                                                  {item.value.substr(0, item.matchIndex)}
                                                  <span className="suggestion-text">{item.value.substr(item.matchIndex, inputValue.length)}</span>
                                                  {item.value.substr(item.matchIndex + inputValue.length)} - {item.marketName}
                                               </p>
                                               <p>{item.content}</p>
                                            </li>
                                         ))
                                       : null}
                                 </ul>
                              </div>
                           );
                        }}
                     </Downshift>
                  </div>
                  <div className="navigation">
                     {/* <NavLink activeClassName="active" to="/banggia/fav">
              <img className="imgstar" src="/static/img/icon/icon-star-gray.svg" alt="img" />
              {t("danhMucTheoDoi")}
            </NavLink> */}

                     {TVSIPriceBoardHasAuth === AuthConfig.No && (
                        <NavLink
                           activeClassName="active"
                           to="/banggia/tong-hop"
                           onClick={() => {
                              setTabNameDisplay(t("tongHop"));
                           }}
                        >
                           {t("tongHop")}
                        </NavLink>
                     )}

                     {TVSIPriceBoardHasAuth === AuthConfig.Yes && (
                        <div className="menu-haschild">
                           <div>
                              <NavLink
                                 activeClassName="active"
                                 to="/banggia/fav"
                                 onClick={() => {
                                    setTabNameDisplay(currentCategoryStock ? currentCategoryStock?.listname : t("danhMucQuanTam"));
                                 }}
                              >
                                 {currentCategoryStock ? currentCategoryStock?.listname : t("danhMucQuanTam")}
                                 <img className="imgcaret" src="/static/img/icon/icon-caretdown.svg" alt="img" />
                              </NavLink>
                           </div>
                           <ResizeObserver ref={refElementCalcCKSHChild} onResize={_calcMenuCKSHChildPosition} onPosition={_calcMenuCKSHChildPosition} onReflow={_calcMenuCKSHChildPosition} />
                           <div ref={refMenuCKSHChild} className="menu-child">
                              <div className="listown">
                                 <div className="listown__controls">
                                    <input placeholder={t("taoDanhMucMoi")} name="nameCategory" value={nameCategory} onChange={handleChangeCategoryName} onKeyDown={handleKeydownCategory} />
                                    <button onClick={handleAddCategoryName} className="listown__add">
                                       <i className="fa fa-plus"></i>
                                    </button>
                                 </div>

                                 {listCategory}
                              </div>
                           </div>
                        </div>
                     )}

                     {/* <NavLink activeClassName="active" to="/banggia/hsx">HSX</NavLink> */}
                     <div className="menu-haschild">
                        <div>
                           <NavLink
                              activeClassName="active"
                              to={menuHSXConfig.href}
                              onClick={() => {
                                 setTabNameDisplay(t("HSX"));
                              }}
                           >
                              {t("HSX")}
                              <img className="imgcaret" src="/static/img/icon/icon-caretdown.svg" alt="img" />
                           </NavLink>
                        </div>
                        <ResizeObserver ref={refElementCalcHSXChild} onResize={_calcMenuHSXChildPosition} onPosition={_calcMenuHSXChildPosition} onReflow={_calcMenuHSXChildPosition} />
                        <div ref={refMenuHSXChild} className="menu-child">
                           <div>
                              <NavLink
                                 exact={true}
                                 activeClassName="active"
                                 to="/banggia/hsx"
                                 onClick={() => {
                                    setTabNameDisplay(t("HSX"));
                                 }}
                              >
                                 {t("HSX")}
                              </NavLink>
                           </div>
                           <div>
                              <NavLink
                                 activeClassName="active"
                                 to="/banggia/vn30"
                                 onClick={() => {
                                    setTabNameDisplay(t("VN30"));
                                 }}
                              >
                                 VN30
                              </NavLink>
                           </div>
                           <div>
                              <NavLink
                                 activeClassName="active"
                                 to="/banggia/hsx/odd"
                                 onClick={() => {
                                    setTabNameDisplay(t("loLe"));
                                 }}
                              >
                                 {t("loLe")}
                              </NavLink>
                           </div>
                           {/* 03/04/2025 Longdh thêm tab thoả thuận theo y/c */}
                           <div>
                              <NavLink
                                 activeClassName="active"
                                 to="/banggia/hsx/thoathuan"
                                 onClick={() => {
                                    setTabNameDisplay(t("giaoDichThoaThuan"));
                                 }}
                              >
                                 {t("giaoDichThoaThuan")}
                              </NavLink>
                           </div>
                        </div>
                     </div>
                     {/* <NavLink activeClassName="active" to="/banggia/vn30">
              VN30
            </NavLink> */}
                     {/* <NavLink activeClassName="active" to="/banggia/hnx">HNX</NavLink> */}
                     <div className="menu-haschild">
                        <div>
                           <NavLink
                              activeClassName="active"
                              to={menuHNXConfig.href}
                              onClick={() => {
                                 setTabNameDisplay(t("HNX"));
                              }}
                           >
                              {t("HNX")}
                              {/*{menuHNXConfig.extTitle !== "" ? " (" + (language === "en" ? menuHNXConfig.extTitleEn : language === "zh" ? menuHNXConfig.extTitleZh : menuHNXConfig.extTitle) + ")" : ""}{" "} */}
                              <img className="imgcaret" src="/static/img/icon/icon-caretdown.svg" alt="img" />
                           </NavLink>
                        </div>
                        <ResizeObserver ref={refElementCalcHNXChild} onResize={_calcMenuHNXChildPosition} onPosition={_calcMenuHNXChildPosition} onReflow={_calcMenuHNXChildPosition} />
                        <div ref={refMenuHNXChild} className="menu-child">
                           <div>
                              <NavLink
                                 exact={true}
                                 activeClassName="active"
                                 to="/banggia/hnx"
                                 onClick={() => {
                                    setTabNameDisplay(t("HNX"));
                                 }}
                              >
                                 {t("HNX")}
                              </NavLink>
                           </div>
                           <div>
                              <NavLink
                                 activeClassName="active"
                                 to="/banggia/hnx/odd"
                                 onClick={() => {
                                    setTabNameDisplay(t("loLe"));
                                 }}
                              >
                                 {t("loLe")}
                              </NavLink>
                           </div>
                           <div>
                              <NavLink
                                 activeClassName="active"
                                 to="/banggia/hnx30"
                                 onClick={() => {
                                    setTabNameDisplay("HNX30");
                                 }}
                              >
                                 HNX30
                              </NavLink>
                           </div>
                           {/* 03/04/2025 Longdh thêm tab thoả thuận theo y/c */}
                           <div>
                              <NavLink
                                 activeClassName="active"
                                 to="/banggia/hnx/thoathuan"
                                 onClick={() => {
                                    setTabNameDisplay("giaoDichThoaThuan");
                                 }}
                              >
                                 {t("giaoDichThoaThuan")}
                              </NavLink>
                           </div>
                        </div>
                     </div>
                     {/* <NavLink activeClassName="active" to="/banggia/hnx30">
              HNX30
            </NavLink> */}

                     {/* đóng tạm 3/4/2025 */}
                     {/* <NavLink activeClassName="active" to="/banggia/upcom"
              onClick={() => {
                setTabNameDisplay(t("UPCOM"));
              }}
            >
              {t("UPCOM")}
            </NavLink> */}

                     {/* 03/04/2025 Longdh thêm tab thoả thuận theo y/c và chỉnh sửa tab upcom */}
                     <div className="menu-haschild">
                        <div>
                           <NavLink
                              activeClassName="active"
                              to={menuUpCOMConfig.href}
                              onClick={() => {
                                 setTabNameDisplay(t("UPCOM"));
                              }}
                           >
                              {t("UPCOM")}
                              <img className="imgcaret" src="/static/img/icon/icon-caretdown.svg" alt="img" />
                           </NavLink>
                        </div>
                        <ResizeObserver ref={refElementCalcUpCOMChild} onResize={_calcMenuUpCOMChildPosition} onPosition={_calcMenuUpCOMChildPosition} onReflow={_calcMenuUpCOMChildPosition} />
                        <div ref={refMenuUpCOMChild} className="menu-child">
                           <div>
                              <NavLink exact={true} activeClassName="active" to="/banggia/upcom">
                                 {t("UPCOM")}
                              </NavLink>
                           </div>
                           <div>
                              <NavLink
                                 activeClassName="active"
                                 to="/banggia/upcom/odd"
                                 onClick={() => {
                                    setTabNameDisplay(t("loLe"));
                                 }}
                              >
                                 {t("loLe")}
                              </NavLink>
                           </div>
                           <div>
                              <NavLink
                                 activeClassName="active"
                                 to="/banggia/upcom/thoathuan"
                                 onClick={() => {
                                    setTabNameDisplay("giaoDichThoaThuan");
                                 }}
                              >
                                 {t("giaoDichThoaThuan")}
                              </NavLink>
                           </div>
                        </div>
                     </div>

                     {/* {useDerivative && useDerivative === "Y" ? (
              <NavLink activeClassName="active" to="/banggia/phaisinh">
                {t("phaiSinh")}
              </NavLink>
            ) : null} */}

                     <div className="menu-haschild">
                        <div>
                           <NavLink
                              activeClassName="active"
                              to={menuIndustryConfig.href}
                              onClick={() => {
                                 setTabNameDisplay(
                                    t("nganh") +
                                       (menuIndustryConfig.extTitle !== ""
                                          ? " (" + (language === "en" ? menuIndustryConfig.extTitleEn : language === "zh" ? menuIndustryConfig.extTitleZh : menuIndustryConfig.extTitle) + ")"
                                          : "")
                                 );
                              }}
                           >
                              {t("nganh") +
                                 (menuIndustryConfig.extTitle !== ""
                                    ? " (" + (language === "en" ? menuIndustryConfig.extTitleEn : language === "zh" ? menuIndustryConfig.extTitleZh : menuIndustryConfig.extTitle) + ")"
                                    : "")}{" "}
                              <img className="imgcaret" src="/static/img/icon/icon-caretdown.svg" alt="img" />
                           </NavLink>
                        </div>
                        <ResizeObserver
                           ref={refElementCalcIndustryChild}
                           onResize={_calcMenuIndustryChildPosition}
                           onPosition={_calcMenuIndustryChildPosition}
                           onReflow={_calcMenuIndustryChildPosition}
                        />
                        <div ref={refMenuIndustryChild} className="menu-child">
                           <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
                              {industries &&
                                 industries.map((el, index) => {
                                    return (
                                       <NavLink
                                          key={index}
                                          className={"text-left"}
                                          activeClassName="active"
                                          to={"/banggia/nganh/" + el.code}
                                          onClick={() => {
                                             setTabNameDisplay(language === "en" ? t("codeIndustry_" + el.code) : language === "zh" ? t("codeIndustry_" + el.code) : t("codeIndustry_" + el.code));
                                          }}
                                       >
                                          {/* {language === "en"
                            ? el.nameEn && el.nameEn !== ""
                              ? el.nameEn
                              : el.name
                            : el.name} */}

                                          {language === "en" ? t("codeIndustry_" + el.code) : language === "zh" ? t("codeIndustry_" + el.code) : t("codeIndustry_" + el.code)}
                                       </NavLink>
                                    );
                                 })}
                           </div>
                        </div>
                     </div>

                     <div className="menu-haschild">
                        <div>
                           <NavLink
                              activeClassName="active"
                              to={menuTopConfig.href !== "" ? menuTopConfig.href : "/banggia/top-incr-prc"}
                              onClick={() => {
                                 setTabNameDisplay(
                                    "Hottrend" +
                                       (menuTopConfig.extTitle !== ""
                                          ? " (" + (language === "en" ? menuTopConfig.extTitleEn : language === "zh" ? menuTopConfig.extTitleZh : menuTopConfig.extTitle) + ")"
                                          : "")
                                 );
                              }}
                           >
                              {"Hottrend" +
                                 (menuTopConfig.extTitle !== ""
                                    ? " (" + (language === "en" ? menuTopConfig.extTitleEn : language === "zh" ? menuTopConfig.extTitleZh : menuTopConfig.extTitle) + ")"
                                    : "")}{" "}
                              <img className="imgcaret" src="/static/img/icon/icon-caretdown.svg" alt="img" />
                           </NavLink>
                        </div>
                        <ResizeObserver ref={refElementCalcTopChild} onResize={_calcMenuTopChildPosition} onPosition={_calcMenuTopChildPosition} onReflow={_calcMenuTopChildPosition} />
                        <div ref={refMenuTopChild} className="menu-child">
                           <div
                              style={{
                                 display: "grid",
                                 gridTemplateColumns: "auto auto auto auto",
                              }}
                           >
                              <NavLink
                                 to="/banggia/top-incr-prc"
                                 onClick={() => {
                                    setTabNameDisplay(t("tangGia"));
                                 }}
                              >
                                 {t("tangGia")}
                              </NavLink>
                              <NavLink
                                 activeClassName="active"
                                 to="/banggia/top-incr-prc/hsx"
                                 onClick={() => {
                                    setTabNameDisplay(t("HSX"));
                                 }}
                              >
                                 {t("HSX")}
                              </NavLink>
                              <NavLink
                                 activeClassName="active"
                                 to="/banggia/top-incr-prc/hnx"
                                 onClick={() => {
                                    setTabNameDisplay(t("HNX"));
                                 }}
                              >
                                 {t("HNX")}
                              </NavLink>
                              <NavLink
                                 activeClassName="active"
                                 to="/banggia/top-incr-prc/upcom"
                                 onClick={() => {
                                    setTabNameDisplay(t("UPCOM"));
                                 }}
                              >
                                 {t("UPCOM")}
                              </NavLink>
                              {/*  */}
                              <NavLink
                                 to="/banggia/top-decr-prc"
                                 onClick={() => {
                                    setTabNameDisplay(t("giamGia"));
                                 }}
                              >
                                 {t("giamGia")}
                              </NavLink>
                              <NavLink
                                 activeClassName="active"
                                 to="/banggia/top-decr-prc/hsx"
                                 onClick={() => {
                                    setTabNameDisplay(t("HSX"));
                                 }}
                              >
                                 {t("HSX")}
                              </NavLink>
                              <NavLink
                                 activeClassName="active"
                                 to="/banggia/top-decr-prc/hnx"
                                 onClick={() => {
                                    setTabNameDisplay(t("HNX"));
                                 }}
                              >
                                 {t("HNX")}
                              </NavLink>
                              <NavLink
                                 activeClassName="active"
                                 to="/banggia/top-decr-prc/upcom"
                                 onClick={() => {
                                    setTabNameDisplay(t("UPCOM"));
                                 }}
                              >
                                 {t("UPCOM")}
                              </NavLink>
                              {/*  */}
                              <NavLink
                                 to="/banggia/top-vol"
                                 onClick={() => {
                                    setTabNameDisplay(t("khoiLuong"));
                                 }}
                              >
                                 {t("khoiLuong")}
                              </NavLink>
                              <NavLink
                                 activeClassName="active"
                                 to="/banggia/top-vol/hsx"
                                 onClick={() => {
                                    setTabNameDisplay(t("HSX"));
                                 }}
                              >
                                 {t("HSX")}
                              </NavLink>
                              <NavLink
                                 activeClassName="active"
                                 to="/banggia/top-vol/hnx"
                                 onClick={() => {
                                    setTabNameDisplay(t("HNX"));
                                 }}
                              >
                                 {t("HNX")}
                              </NavLink>
                              <NavLink
                                 activeClassName="active"
                                 to="/banggia/top-vol/upcom"
                                 onClick={() => {
                                    setTabNameDisplay(t("UPCOM"));
                                 }}
                              >
                                 {t("UPCOM")}
                              </NavLink>
                              {/*  */}
                              <NavLink
                                 to="/banggia/top-fbuy"
                                 onClick={() => {
                                    setTabNameDisplay(t("nnMua"));
                                 }}
                              >
                                 {t("nnMua")}
                              </NavLink>
                              <NavLink
                                 activeClassName="active"
                                 to="/banggia/top-fbuy/hsx"
                                 onClick={() => {
                                    setTabNameDisplay(t("HSX"));
                                 }}
                              >
                                 {t("HSX")}
                              </NavLink>
                              <NavLink
                                 activeClassName="active"
                                 to="/banggia/top-fbuy/hnx"
                                 onClick={() => {
                                    setTabNameDisplay(t("HNX"));
                                 }}
                              >
                                 {t("HNX")}
                              </NavLink>
                              <NavLink
                                 activeClassName="active"
                                 to="/banggia/top-fbuy/upcom"
                                 onClick={() => {
                                    setTabNameDisplay(t("UPCOM"));
                                 }}
                              >
                                 {t("UPCOM")}
                              </NavLink>
                              {/*  */}
                              <NavLink
                                 to="/banggia/top-fsell"
                                 onClick={() => {
                                    setTabNameDisplay(t("nnBan"));
                                 }}
                              >
                                 {t("nnBan")}
                              </NavLink>
                              <NavLink
                                 activeClassName="active"
                                 to="/banggia/top-fsell/hsx"
                                 onClick={() => {
                                    setTabNameDisplay(t("HSX"));
                                 }}
                              >
                                 {t("HSX")}
                              </NavLink>
                              <NavLink
                                 activeClassName="active"
                                 to="/banggia/top-fsell/hnx"
                                 onClick={() => {
                                    setTabNameDisplay(t("HNX"));
                                 }}
                              >
                                 {t("HNX")}
                              </NavLink>
                              <NavLink
                                 activeClassName="active"
                                 to="/banggia/top-fsell/upcom"
                                 onClick={() => {
                                    setTabNameDisplay(t("UPCOM"));
                                 }}
                              >
                                 {t("UPCOM")}
                              </NavLink>
                           </div>
                        </div>
                     </div>

                     <NavLink
                        activeClassName="active"
                        to="/banggia/chungquyen"
                        onClick={() => {
                           setTabNameDisplay(t("chungQuyen"));
                        }}
                     >
                        {t("chungQuyen")}
                     </NavLink>

                     {/* <div className="menu-haschild">
              <div>
                <NavLink activeClassName="active" to={menuPutThroughConfigHref}>
                  {t("thoaThuan")} {menuPutThroughConfigTitle !== "" ? " (" + menuPutThroughConfigTitle + ")" : ""}
                  <img className="imgcaret" src="/static/img/icon/icon-caretdown.svg" alt="img" />
                </NavLink>
              </div>
              <ResizeObserver
                ref={refElementCalcPutThroughChild}
                onResize={_calcMenuPutThroughChildPosition}
                onPosition={_calcMenuPutThroughChildPosition}
                onReflow={_calcMenuPutThroughChildPosition}
              />
              <div ref={refMenuPutThroughChild} className="menu-child">
                <div>
                  <NavLink activeClassName="active" to="/banggia/thoathuan/all">
                    {t("tongHopAll")}
                  </NavLink>
                </div>
                <div>
                  <NavLink activeClassName="active" to="/banggia/thoathuan/hsx">
                    HSX
                  </NavLink>
                </div>
                <div>
                  <NavLink activeClassName="active" to="/banggia/thoathuan/hnx">
                    HNX
                  </NavLink>
                </div>
                <div>
                  <NavLink activeClassName="active" to="/banggia/thoathuan/upcom">
                    UpCOM
                  </NavLink>
                </div>
              </div>
            </div> */}

                     {/* 26/03/2025 SangDD y/c bỏ phái sinh */}
                     {/* <div className="menu-haschild">
              <div>
                <NavLink activeClassName="active" to={menuPSConfigHref}
                  onClick={() => {
                    setTabNameDisplay(`${t("phaiSinh")} ${menuPSConfigTitle}` !== "" ? " (" + menuPSConfigTitle + ")" : "");
                  }}
                >
                  {t("phaiSinh")} {menuPSConfigTitle !== "" ? " (" + menuPSConfigTitle + ")" : ""}
                  <img className="imgcaret" src="/static/img/icon/icon-caretdown.svg" alt="img" />
                </NavLink>
              </div>
              <ResizeObserver ref={refElementCalcPSChild} onResize={_calcMenuPSChildPosition} onPosition={_calcMenuPSChildPosition} onReflow={_calcMenuPSChildPosition} />
              <div ref={refMenuPSChild} className="menu-child">
                <div>
                  <NavLink activeClassName="active" to="/banggia/phaisinh/vn30"
                    onClick={() => {
                      setTabNameDisplay(t("HDTLVN30"));
                    }}
                  >
                    {t("HDTLVN30")}
                  </NavLink>
                </div>
                <div>
                  <NavLink activeClassName="active" to="/banggia/phaisinh/tpcp"
                    onClick={() => {
                      setTabNameDisplay(t("HDTLTPCP"));
                    }}
                  >
                    {t("HDTLTPCP")}
                  </NavLink>
                </div>
              </div>
            </div> */}

                     {/* <NavLink activeClassName="active" to="/banggia/traiphieu">{t("traiPhieu")}</NavLink> */}
                     <NavLink
                        activeClassName="active"
                        to="/banggia/tprl"
                        onClick={() => {
                           setTabNameDisplay(t("traiphieuriengle"));
                        }}
                     >
                        {t("traiphieuriengle")}
                     </NavLink>

                     <div className="menu-haschild">
                        <div>
                           <NavLink
                              activeClassName="active"
                              to={menuExpandConfig}
                              onClick={() => {
                                 setTabNameDisplay(t("lblExpand"));
                              }}
                           >
                              {t("lblExpand")}
                              <img className="imgcaret" src="/static/img/icon/icon-caretdown.svg" alt="img" />
                           </NavLink>
                        </div>
                        <ResizeObserver ref={refEleCalExpandChild} onResize={_calcMenuExpandChildPosition} onPosition={_calcMenuExpandChildPosition} onReflow={_calcMenuExpandChildPosition} />
                        <div ref={refMenuExpandChild} className="menu-child">
                           <div>
                              <NavLink
                                 activeClassName="active"
                                 to="/banggia/mo-rong"
                                 onClick={() => {
                                    setTabNameDisplay(t("lblExpand"));
                                 }}
                              >
                                 {t("lblExpand")}
                              </NavLink>
                           </div>
                           <div>
                              <NavLink activeClassName="active" to={fileHDSD} target="_blank">
                                 {t("huongDanSuDung")}
                              </NavLink>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="price-menu-right">
                  <div className="pricemenu__left">
                     {/* <div
              title={t("chiTiet")}
              className={priceBoardViewMode === "DETAIL" ? "active" : ""}
              onClick={() => _changePriceBoardViewMode("DETAIL")}
            >
              <img src="/static/img/icon/icon-list-table.svg" alt="img" />
            </div>
            <div
              title={t("Thumbnail")}
              className={priceBoardViewMode === "BOX" ? "active" : ""}
              onClick={() => _changePriceBoardViewMode("BOX")}
            >
              <img src="/static/img/icon/icon-grid.svg" alt="img" />
            </div>
            <div
              title={t("tongHop")}
              className={priceBoardViewMode === "TOTAL" ? "active" : ""}
              onClick={() => _changePriceBoardViewMode("TOTAL")}
            >
              <img src="/static/img/icon/icon-item.svg" alt="img" />
            </div> */}
                     <div className="timeline m-0">
                        <div className="timeline__now">
                           {/* <span style={{ color: "transparent" }}>
                  t:{concurrentInfo.total}-m:{concurrentInfo.max}-c:{concurrentInfo.current}-
                </span> */}
                           {serverDate.toLocaleTimeString("en-GB")}
                        </div>
                        <div className="timeline__date">{serverDate.toLocaleDateString("en-GB")}</div>
                     </div>
                  </div>
                  <div className="pricemenu__right">
                     {/* {language === "en" ? (
                  <img src="/static/img/icon/icon-language-en.svg" alt={t("tiengAnh")} />
                ) : language === "zh" ? (
                  <img src="/static/img/icon/icon-language-zh.svg" alt={t("tiengTrung")} />
                ) : (
                  <img src="/static/img/icon/icon-language-vi.svg" alt={t("tiengViet")} />
                )} */}
                     <button className="btn-cog">
                        <ResizeObserver ref={refElementCalcConfigColumn} onResize={_calcMenuCalcConfigPosition} onPosition={_calcMenuCalcConfigPosition} onReflow={_calcMenuCalcConfigPosition} />
                        <i className="fas fa-cog"></i>

                        <ul ref={refDivConfigColumn} className="ul-setup">
                           <Checkbox.Group onChange={onChangeConfigColumn} defaultValue={configShowHideColumn}>
                              <li className="cbSetup">
                                 <Checkbox value="colSubSymbol" checked={configShowHideColumn.includes("colSubSymbol")}>
                                    <label>{t("maCK")}</label>
                                 </Checkbox>
                              </li>
                              <li className="cbSetup">
                                 <Checkbox value="colBuyVol4" checked={configShowHideColumn.includes("colBuyVol4")}>
                                    {t("khoiLuongMua4")}
                                 </Checkbox>
                              </li>
                              <li className="cbSetup">
                                 <Checkbox value="colSellVol4" checked={configShowHideColumn.includes("colSellVol4")}>
                                    {t("khoiLuongBan4")}
                                 </Checkbox>
                              </li>
                              <li className="cbSetup">
                                 <Checkbox value="colTotalBuy" checked={configShowHideColumn.includes("colTotalBuy")}>
                                    {t("tongKL")}
                                 </Checkbox>
                              </li>
                              <li className="cbSetup">
                                 <Checkbox value="colNNbuy" checked={configShowHideColumn.includes("colNNbuy")}>
                                    {t("nnMua")}
                                 </Checkbox>
                              </li>
                              <li className="cbSetup">
                                 <Checkbox value="colNNsell" checked={configShowHideColumn.includes("colNNsell")}>
                                    {t("nnBan")}
                                 </Checkbox>
                              </li>
                              <li className="cbSetup">
                                 <Checkbox value="colRoom" checked={configShowHideColumn.includes("colRoom")}>
                                    {t("room")}
                                 </Checkbox>
                              </li>
                           </Checkbox.Group>
                        </ul>
                     </button>

                     <button className={clsx("btn-cog", marketCode == constMarketCode.Derivative ? "hidden" : "")}>
                        <ResizeObserver
                           ref={refElementCalFilterColumn}
                           onResize={_calcMenuSortColumnmConfigPosition}
                           onPosition={_calcMenuSortColumnmConfigPosition}
                           onReflow={_calcMenuSortColumnmConfigPosition}
                        />
                        <i className="fas fa-filter"></i>
                        <ul ref={refDivSortConfigColumn} className="ul-setup-sort">
                           <Radio.Group onChange={onChangeSortConfigColumn} defaultValue={configSortColumnMenu}>
                              <li className="cbSetup">
                                 <label className="lbl"> {t("maCK")}</label>
                                 <Radio value="symbolColDesc" checked={configSortColumnMenu.includes("symbolColDesc")}>
                                    {t("tang")}
                                 </Radio>
                                 <Radio value="symbolColAsc" checked={configSortColumnMenu.includes("symbolColAsc")}>
                                    {t("giam")}
                                 </Radio>
                              </li>
                              <li className="cbSetup">
                                 <label className="lbl"> {t("tongKL")}</label>
                                 <Radio value="totalQttyColDesc" checked={configSortColumnMenu.includes("totalQttyColDesc")}>
                                    {t("tang")}
                                 </Radio>
                                 <Radio value="totalQttyColAsc" checked={configSortColumnMenu.includes("totalQttyColAsc")}>
                                    {t("giam")}
                                 </Radio>
                              </li>
                              <li className="cbSetup">
                                 <label className="lbl"> {t("nnMua")}</label>
                                 <Radio value="foreignBuyColDesc" checked={configSortColumnMenu.includes("foreignBuyColDesc")}>
                                    {t("tang")}
                                 </Radio>
                                 <Radio value="foreignBuyColAsc" checked={configSortColumnMenu.includes("foreignBuyColAsc")}>
                                    {t("giam")}
                                 </Radio>
                              </li>
                              <li className="cbSetup">
                                 <label className="lbl"> {t("nnBan")}</label>
                                 <Radio value="foreignSellColDesc" checked={configSortColumnMenu.includes("foreignSellColDesc")}>
                                    {t("tang")}
                                 </Radio>
                                 <Radio value="foreignSellColAsc" checked={configSortColumnMenu.includes("foreignSellColAsc")}>
                                    {t("giam")}
                                 </Radio>
                              </li>
                           </Radio.Group>
                        </ul>
                     </button>
                     <select className="input-default change-language" onChange={(e) => handleChangeLanguage(e.target.value)}>
                        <option selected={language === "vi" ? true : false} value="vi">
                           {t("tiengViet")}
                        </option>
                        <option selected={language === "en" ? true : false} value="en">
                           {t("tiengAnh")}
                        </option>
                        <option selected={language === "zh" ? true : false} value="zh">
                           {t("tiengTrung")}
                        </option>
                        <option selected={language === "kr" ? true : false} value="kr">
                           {t("tiengHan")}
                        </option>
                     </select>

                     {TVSIPriceBoardHasAuth === "1" ? (
                        userName !== "" ? (
                           <button className="btn__login d-none-mb" onClick={_userLogout}>
                              <span>
                                 {/* <span className="fw-700 text-uppercase">{userName}</span> - {t("dangXuat")} */}
                                 {t("dangXuat")}
                              </span>
                           </button>
                        ) : (
                           <button className="btn__login d-none-mb">
                              {/* <img src="/static/img/icon/icon-login.svg" alt="img" /> */}
                              <span>{t("dangNhap")}</span>
                           </button>
                        )
                     ) : (
                        <></>
                     )}

                     {/* {priceBoardViewMode === "DETAIL" ? <PriceBoardColumnConfig priceBoardViewMode={priceBoardViewMode} /> : null} */}

                     {/* {priceBoardIndexMode && priceBoardIndexMode === "HIDDEN" ? (
              <button type="button" onClick={handleChangePriceBoardIndexMode}>
                <i className="fa fa-arrow-down"></i>{" "}
              </button>
            ) : (
              <button type="button" onClick={handleChangePriceBoardIndexMode}>
                <i className="fa fa-arrow-up"></i>{" "}
              </button>
            )} */}
                  </div>
               </div>
            </div>
         )}

         {tabName && isPutThrough ? (
            <PriceBoardPutThrough tabName={tabName} />
         ) : tabName && tabName == constTabName.EXPAND ? (
            <PriceBoardExpandMode tabName={tabName} />
         ) : marketCode && marketCode === constMarketCode.Derivative ? (
            <PriceBoardDerivative updateTime={forceUpdateTime} symbolInfos={symbolInfos} tabName={tabName} />
         ) : marketCode && marketCode === constMarketCode.TPRL ? (
            <PriceBoardTPRL updateTime={forceUpdateTime} symbolInfos={symbolInfos} tabName={tabName} />
         ) : priceBoardViewMode === "DETAIL" && isOddLot ? (
            // <PriceBoardOddDetailMode updateTime={forceUpdateTime} symbolInfos={symbolInfos} tabName={tabName} isOddLot={isOddLot} />
            <PriceBoardOddDetailModeAGGrid updateTime={forceUpdateTime} symbolInfos={symbolInfos} tabName={tabName} isOddLot={isOddLot} />
         ) : priceBoardViewMode === "DETAIL" ? (
            // <PriceBoardDetailMode updateTime={forceUpdateTime} symbolInfos={symbolInfos} tabName={tabName} isOddLot={isOddLot} />
            <PriceBoardDetailModeAGGrid updateTime={forceUpdateTime} symbolInfos={symbolInfos} tabName={tabName} isOddLot={isOddLot} isAutoScroll={props.isAutoScroll} />
         ) : priceBoardViewMode === "BOX" ? (
            <PriceBoardBoxMode2 updateTime={forceUpdateTime} symbolInfos={symbolInfos} tabName={tabName} isOddLot={isOddLot} />
         ) : priceBoardViewMode === "TOTAL" && isOddLot ? (
            <PriceBoardOddTotalMode updateTime={forceUpdateTime} symbolInfos={symbolInfos} tabName={tabName} isOddLot={isOddLot} />
         ) : priceBoardViewMode === "TOTAL" ? (
            <PriceBoardTotalMode updateTime={forceUpdateTime} symbolInfos={symbolInfos} tabName={tabName} isOddLot={isOddLot} />
         ) : (
            <></>
         )}

         <Footer showUnitNote={!tabName || !isPutThrough ? true : false} isOddLot={isOddLot} isAutoScroll={props.isAutoScroll} />
      </>
   );
}

//
const PriceBoardColumnConfig = (props) => {
   const { priceBoardViewMode } = props;

   const [showConfigView, setShowConfigView] = useState(false);

   const refContainer = useRef(null);
   const refChooseCode = useRef(null);
   const refChooseCodeMatch = useRef(null);
   const refChooseTotalTradedQtty = useRef(null);
   const refChooseBuyForeignQtty = useRef(null);
   const refChooseSellForeignQtty = useRef(null);
   const refChooseRemainForeignQtty = useRef(null);

   const dispatch = useDispatch();
   const { t } = useTranslation();

   const priceBoardColumnConfig_UpdateTime = useSelector((state) => state.gShared.priceBoardColumnConfig?.updateTime);
   const priceBoardColumnConfig = useSelector((state) => state.gShared.priceBoardColumnConfig);
   const configByViewMode = priceBoardColumnConfig ? priceBoardColumnConfig[priceBoardViewMode] ?? {} : {};
   //
   const _handleButtonClick = (event) => {
      setShowConfigView(true);
   };

   const _handleContainerClick = (event) => {
      if (refContainer && refContainer.current === event.target) {
         setShowConfigView(false);
      }
   };

   const _handleSaveClick = () => {
      try {
         if (priceBoardViewMode === "DETAIL") {
            const showCode = refChooseCode.current ? refChooseCode.current.checked : false;
            const showCodeMatch = refChooseCodeMatch.current ? refChooseCodeMatch.current.checked : false;
            const showTotalTradedQtty = refChooseTotalTradedQtty.current ? refChooseTotalTradedQtty.current.checked : false;
            const showBuyForeignQtty = refChooseBuyForeignQtty.current ? refChooseBuyForeignQtty.current.checked : false;
            const showSellForeignQtty = refChooseSellForeignQtty.current ? refChooseSellForeignQtty.current.checked : false;
            const showRemainForeignQtty = refChooseRemainForeignQtty.current ? refChooseRemainForeignQtty.current.checked : false;
            //
            let data = Object.assign(priceBoardColumnConfig ?? {}, {
               updateTime: new Date().getTime(),
               [priceBoardViewMode]: {
                  showCode: showCode,
                  showCodeMatch: showCodeMatch,
                  showTotalTradedQtty: showTotalTradedQtty,
                  showBuyForeignQtty: showBuyForeignQtty,
                  showSellForeignQtty: showSellForeignQtty,
                  showRemainForeignQtty: showRemainForeignQtty,
               },
            });
            //
            savePriceBoardColumnConfigToStorage(data);
            dispatch({ type: "SetPriceBoardColumnConfig", payload: data });
         }
         setShowConfigView(false);
      } catch (error) {
         console.log("Column config", error);
      }
   };

   const _setInputCheckState = () => {
      if (
         refChooseCode.current &&
         refChooseCodeMatch.current &&
         refChooseTotalTradedQtty.current &&
         refChooseBuyForeignQtty.current &&
         refChooseSellForeignQtty.current &&
         refChooseRemainForeignQtty.current
      ) {
         refChooseCode.current.checked = configByViewMode.showCode;
         refChooseCodeMatch.current.checked = configByViewMode.showCodeMatch;
         refChooseTotalTradedQtty.current.checked = configByViewMode.showTotalTradedQtty;
         refChooseBuyForeignQtty.current.checked = configByViewMode.showBuyForeignQtty;
         refChooseSellForeignQtty.current.checked = configByViewMode.showSellForeignQtty;
         refChooseRemainForeignQtty.current.checked = configByViewMode.showRemainForeignQtty;
      } else {
         setTimeout(_setInputCheckState, 250);
      }
   };

   //
   useEffect(() => {
      _setInputCheckState();
   }, [showConfigView, priceBoardColumnConfig_UpdateTime]);

   //
   return (
      <div>
         <button
            type="button"
            onClick={() => {
               _handleButtonClick();
            }}
         >
            <i className="fa fa-cog"></i>
         </button>
         {showConfigView && priceBoardViewMode && priceBoardViewMode === "DETAIL" && (
            <div ref={refContainer} onClick={_handleContainerClick} className="popup-priceboard-columnconfig">
               <div>
                  <div className="popup-priceboard-columnconfig__header">
                     <b>Tùy chọn cột hiển thị trên bảng giá</b>
                  </div>
                  <div className="popup-priceboard-columnconfig__content">
                     <div className="checkbox-order">
                        <input ref={refChooseCode} type={"checkbox"}></input>
                        <label>{t("maCK")}</label>
                     </div>
                     <div className="checkbox-order">
                        <input ref={refChooseCodeMatch} type={"checkbox"}></input>
                        <label>
                           {t("maCK")} - {t("khop")}
                        </label>
                     </div>
                     <div className="checkbox-order">
                        <input ref={refChooseTotalTradedQtty} type={"checkbox"}></input>
                        <label>{t("tongKL")}</label>
                     </div>
                     <div className="checkbox-order">
                        <input ref={refChooseBuyForeignQtty} type={"checkbox"}></input>
                        <label>{t("nnMua")}</label>
                     </div>
                     <div className="checkbox-order">
                        <input ref={refChooseSellForeignQtty} type={"checkbox"}></input>
                        <label>{t("nnBan")}</label>
                     </div>
                     <div className="checkbox-order">
                        <input ref={refChooseRemainForeignQtty} type={"checkbox"}></input>
                        <label>Room</label>
                     </div>
                     <div className="d-flex justify-content-end">
                        <button className="btn-sv active" onClick={_handleSaveClick}>
                           Lưu
                        </button>
                        <button
                           className="btn-ex"
                           onClick={() => {
                              setShowConfigView(false);
                           }}
                        >
                           Thoát
                        </button>
                     </div>
                  </div>
               </div>
            </div>
         )}
      </div>
   );
};
